mutation DeleteEmail($payload: DeleteEmailInput!) {
    emailDelete(input: $payload) {
        email {
            id
        }
    }
}
